const promptData = {
  home: [
    {
      question: 'What is Vani?',
      followUpQuestions: [
        {
          question: 'How can Vani help me?',
        },
        {
          question: 'What can Vani not do?',
        },
        {
          question: 'How do I get started?',
        },
      ],
    },
    {
      question: 'What is basket investing?',
      followUpQuestions: [
        { question: 'Are returns guaranteed?' },
        { question: 'Where can I learn more?' },
        { question: 'What baskets are available?' },
      ],
    },
    {
      question: 'How are my investments doing?',
      followUpQuestions: [
        {
          question:
            'Are there any stocks in my portfolio that are doing well or poorly?',
        },
        {
          question: 'Can you suggest a basket to invest in?',
        },
        {
          question: 'What other baskets are available?',
        },
      ],
    },
  ],
  explore: [
    {
      question: 'What baskets are available?',
      followUpQuestions: [
        {
          question: 'What metrics can I use to sort the baskets here?',
        },
        {
          question:
            'Which basket has given the highest return in the past 12 months?',
        },
        { question: 'Which is the lowest risk basket?' },
      ],
    },
    {
      question: 'How do I invest?',
      followUpQuestions: [
        {
          question: 'What baskets are available?',
        },
        {
          question: 'What factors can I use to sort or rank the baskets here?',
        },
        {
          question:
            'Which basket has given the highest return in the past 12 months?',
        },
      ],
    },
    {
      question: 'What metrics can I use to sort the baskets here?',
      followUpQuestions: [
        { question: 'Can you rank the baskets by their 12 months return?' },
        { question: 'Which baskets have the lowest risk profile?' },
        { question: 'Are there any free baskets?' },
      ],
    },
  ],
  invest: [
    {
      question: 'How is my portfolio doing?',
      followUpQuestions: [
        {
          question:
            'Are there any stocks in my portfolio that are doing very well or poorly?',
        },
        {
          question: 'What is the sector distribution in my portfolio?',
        },
        {
          question:
            'How does my portfolio’s performance compare to the overall market?',
        },
      ],
    },
    {
      question: 'How is the basket doing?',
      followUpQuestions: [
        {
          question:
            'Which three stocks are currently the top contributors to the performance of my portfolio?',
        },
        {
          question:
            'How does the basket’s performance compare to the overall market?',
        },
        {
          question: 'What is the sector split of the basket?',
        },
      ],
    },
    {
      question:
        'Compare my investments with their corresponding baskets on the platform.',
      followUpQuestions: [
        {
          question: 'Why is there a difference in performance?',
        },
        { question: 'How can I avoid this difference in the performance?' },
      ],
    },
  ],
  rebalance: [
    {
      question: 'What is a rebalance?',
      followUpQuestions: [
        { question: 'What are the steps involved in rebalancing a portfolio?' },
        { question: 'How can I know if my portfolio needs rebalancing?' },
        {
          question: 'What happens if I don’t rebalance?',
        },
      ],
    },
    {
      question:
        'What are the top three best performing stocks in my current rebalance?',
      followUpQuestions: [
        {
          question: 'Can you provide an analysis on these stocks?',
        },
        {
          question:
            'What can I do if I don’t want to invest in one of the recommended stocks from the basket?',
        },
        {
          question: 'What happens if I don’t rebalance?',
        },
      ],
    },
    {
      question: 'What are the steps involved in rebalancing a portfolio?',
      followUpQuestions: [
        {
          question:
            'What can I do if I don’t want to invest in one of the recommended stocks from the basket?',
        },
        { question: 'What happens if I don’t rebalance?' },
      ],
    },
  ],
  learn: [
    {
      question: 'What is Vani?',
      followUpQuestions: [
        {
          question: 'How can Vani help me?',
        },
        {
          question: 'What can Vani not do?',
        },
        {
          question: 'How do I get started?',
        },
      ],
    },
    {
      question: 'What is basket investing?',
      followUpQuestions: [
        { question: 'Are returns guaranteed?' },
        { question: 'Where can I learn more?' },
        { question: 'What baskets are available?' },
      ],
    },
    {
      question: 'How are my investments doing?',
      followUpQuestions: [
        {
          question: 'Are there any stocks that are doing very well or poorly?',
        },
        {
          question: 'Can you suggest a basket to invest in?',
        },
        {
          question: 'What other baskets are available?',
        },
      ],
    },
  ],
};

export { promptData };
